export const setLinks = function (links) {
  return {
    type: 'INIT',
    links,
  };
};
